import styled from "styled-components";
import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { TableBody, TableHead, TableRow, Icon } from "@mui/material";
import { useState } from "react";
import LoadingSpinner from "./LoadingSpinner";

type CourseDropModalProps = {
  url: string;
  loading: boolean;
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  setErrorMessage: any;
  setIsErrorOpen: any;
};
const Title = styled.div`
  font-style: normal;
  //   font-weight: bold;
  font-size: 22px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 0px 24px;
  width: 318px;
  background: rgba(236, 197, 198, 0.1);
  border-radius: 4px;
  margin: 24px 0px;
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding: 16px 0;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 10px;
`;

const DownloadModal = ({
  url,
  loading,
  isOpen,
  setErrorMessage,
  setIsErrorOpen,
  setOpen,
  confirmFunction,
}: CourseDropModalProps): JSX.Element => {
  const [hover, setHover] = useState(false);
  const filename = url.substring(url.lastIndexOf("/") + 1);
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: {
            marginTop: 300,
            minWidth: "600px",
          },
        }}
      >
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <FlexBox
              className="reduce_opct_onhover"
              title={filename}
              // onMouseOver={() => setHover(true)}
              // onMouseLeave={() => setHover(false)}
              style={{
                // minWidth: "600px",
                // padding: "9px",
                margin: 10,
                background: theme.color.greenButton,
                color: "#ffffff",
                borderRadius: 5,
                boxShadow: "0 2px 4px gray",
                cursor: "pointer",
              }}
              //   className="reduce_opct_onhover"
              onClick={confirmFunction}
            >
              <FlexGrow
                style={{
                  display: "flex",
                  justifyContent: "center",
                  opacity: hover ? "0.8" : "",
                }}
              >
                <Title
                  style={{
                    height: "64px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Icon
                    fontSize={hover ? "small" : "large"}
                    style={{ paddingRight: 10, fontSize: 40 }}
                  >
                    download
                  </Icon>{" "}
                  Click here to download exported curriculum
                </Title>
              </FlexGrow>
              {/* <ClickableIcon
            name="close"
            color="white"
            style={{
              background: "#8188e9",
              borderRadius: "50%",
              marginRight: 10,
            }}
            onClick={() => setOpen(false)}
          />{" "} */}
            </FlexBox>
            <div
              onClick={() => {
                setOpen(false);
              }}
              className="reduce_opct_onhover"
              style={{
                marginBottom: 20,
                position: "relative",
                bottom: -10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "gray",
                fontSize: 20,
              }}
            >
              <Icon fontSize="large" style={{ paddingRight: 10 }}>
                close
              </Icon>
              Cancel Download
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default DownloadModal;
